import { render, staticRenderFns } from "./orderselection-component.vue?vue&type=template&id=eaa04a6a"
import script from "./orderselection-component.vue?vue&type=script&lang=ts"
export * from "./orderselection-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports